import { api } from './../../api.js';

import axios from 'axios';

const state = {
	
}

const getters = {
	
}

const mutations = {
	
}

const actions = {

	getUsers : function({ commit }, data){

		return new Promise((resolve, reject) => {

			api.get('admin/users', data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			});
		});
	},

	deleteUser : function({ commit }, data){
		return new Promise((resolve, reject) => {

			api.delete('admin/users/' + data.user_id, data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			});
		});
	},

	assignUserToProvider : function({ commit }, data){
		return new Promise((resolve, reject) => {

			api.post('admin/users/' + data.user_id + '/provider', data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			});
		});
	},

	getUserProviderTableFilters : function({ commit }, data){
		return new Promise((resolve, reject) => {

			api.get('admin/users/filters/providers', data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			});
		});
	},

	createUserProviderTableFilters : function({ commit }, data){
		return new Promise((resolve, reject) => {

			api.post('admin/users/filters/providers', data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			});
		});
	},

	updateUserProviderTableFilters : function({ commit }, data){
		return new Promise((resolve, reject) => {

			api.patch('admin/users/filters/providers/' + data.id, data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			});
		});
	},

	deleteUserProviderTableFilter : function({ commit }, data){
		return new Promise((resolve, reject) => {

			api.delete('admin/users/filters/providers/' + data.id, data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			});
		});
	},

	toggleActiveUserProviderFilter : function({ commit }, data){
		return new Promise((resolve, reject) => {

			api.post('admin/users/filters/providers/' + data.id + '/active', data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			});
		});
	},
}

export default {
	state, 
	actions,
	getters,
	mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/UserModule.js